import React from 'react';
import { Check } from 'lucide-react';
export function Comparison() {
  const comparisons = [{
    title: 'Frameless / Euro',
    bestFor: ['Modern bathroom remodels', 'Showcasing tile or stone', 'Open, airy bathroom designs', 'Homeowners wanting minimal hardware', 'Luxury master bathrooms']
  }, {
    title: 'Semi-Frameless / Framed',
    bestFor: ['Traditional or transitional bathrooms', 'Practical support with a clean look', 'Budget-conscious upgrades', 'Replacing older framed doors', 'Tub and shower combinations']
  }, {
    title: 'Sliding / Bypass',
    bestFor: ['Smaller bathrooms', 'Tub enclosures', 'Openings without swing-door clearance', 'Guest bathrooms', 'Efficient daily use']
  }, {
    title: 'Fixed Panel / Walk-In',
    bestFor: ['Low-curb or curbless showers', 'Accessible bathroom layouts', 'Minimalist designs', 'Open-concept shower spaces', 'Barrier-free entry goals']
  }];
  return <section className="py-20 bg-white" data-id="element-1386" data-mp="34n7t62ctxrc5">
      <div className="container mx-auto px-4 max-w-7xl" data-id="element-1387" data-mp="3jegngorog0vm">
        <div className="text-center max-w-3xl mx-auto mb-16 anim-on-scroll" data-id="element-1388" data-mp="3jgb6fxje1ix2">
          <h2 className="text-3xl md:text-4xl font-bold text-navy mb-6 tracking-normal" data-id="element-1389" data-mp="3elx75k1lurn4">
            Which Glass Shower Door Is Right for Your Bathroom?
          </h2>
        </div>
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 mb-12" data-id="element-1390" data-mp="3nf0jtq4ff0gp">
          {comparisons.map((item, i) => <div key={i} className="bg-gray-50 p-8 rounded-lg border border-gray-100 scroll-fade-up" style={{
          animationDelay: `${i * 0.1}s`
        }} data-id="element-1391" data-mp="676ltpbmq4rs" data-mpi={i}>
              <h3 className="text-xl font-bold text-navy mb-6 pb-4 border-b border-gray-200" data-id="element-1392" data-mp="22zylg0jhn2sj">
                {item.title}
              </h3>
              <p className="text-sm font-semibold text-gray-500 uppercase tracking-normal mb-4" data-id="element-1393" data-mp="2sp5nbyo3es3c">
                Best for:
              </p>
              <ul className="space-y-3" data-id="element-1394" data-mp="2wrsb9ohn7sv9">
                {item.bestFor.map((bullet, j) => <li key={j} className="flex items-start gap-2" data-id="element-1395" data-mp="31qver4hz5r14" data-mpi={j}>
                    <Check className="w-5 h-5 text-primary shrink-0" data-id="element-1396" data-mp="36ook5vbgeh0c" />
                    <span className="text-gray-700" data-id="element-1397" data-mp="3bnhyfpykec1k">{bullet}</span>
                  </li>)}
              </ul>
            </div>)}
        </div>
        <div className="max-w-2xl mx-auto text-center bg-glass p-6 rounded-lg mb-8 anim-on-scroll" data-id="element-1398" data-mp="3fm793as7xfhi">
          <p className="text-navy font-medium" data-id="element-1399" data-mp="3khmldyakv3bt">
            Kosin's Glass can review your layout, measurements, bathroom style
            and usage needs to recommend the best shower glass option.
          </p>
        </div>
        <div className="text-center anim-on-scroll" data-id="element-1400" data-mp="36wuwoopcb5u">
          <a href="#quote" className="inline-flex items-center justify-center bg-navy hover:bg-navy-800 text-white font-semibold py-4 px-8 rounded-lg transition-colors" data-id="element-1401" data-mp="37erxnj6utet">
            Help Me Choose My Shower Door
          </a>
        </div>
      </div>
    </section>;
}